export default __webpack_public_path__ + "static/eco-sustainability-Compostable-badge-139281fbb125f9222318004fad6689de.svg";